import { createRoute, redirect } from '@tanstack/react-router';

import { authRepository } from '@web/data/repositories';
import { AuthCallbackError, AuthCallbackPending, LoginPage } from '@web/ui/auth/views';

import { rootRoute } from './root_routes';

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
  beforeLoad: async () => {
    const token = await authRepository.getAccessToken();
    if (token) redirect({ throw: true, to: '/' });
  },
});

export const authCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/callback',
  component: AuthCallbackPending,
  pendingComponent: AuthCallbackPending,
  errorComponent: AuthCallbackError,
  loader: async () => {
    const { returnTo } = await authRepository.handleAuthCallback();
    redirect({ throw: true, to: returnTo ?? '/' });
  },
});
